import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios'; 
import useUpdateIaProfile from '../Hooks/IAprofileHooks/useUpdateIaProfile'; 
import MunicipalitySelector from '../Components/Municipality';
import MailingAddressSelector from '../Components/MailingAddressSelector';
import adminBg from '../Assets/bg/adminbg.jpg';

const IaProfilingEdit = ({ selectedItem, closeEditPanel, darkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {};  

  const [formData, setFormData] = useState({
    name_of_irrigators: '',
    name_of_cis: '',
    municipality: '',
    district_number: '',
    mailing_address: '',
    name_of_iaPresident: '',
    contactNumber: '',
    date_organized: '',
    sec_number: '',
    sec_date: '',
    ia_tin: '',
    permit_number: '',
    permit_date: '',
    membership_potl: '',
    membership_actual: '',
    number_of_TSAG: '',
    serviceArea: '',
    fusa: '',
    operational_area: '',
    date_moaSigned: '',
    f_source: '',
    proj_cost: '',
    date_turnover: '',
    total_loanBalance: '',
    status: '',
    imtContract_dateSigning: '',
    imtContract_underContract: '',
    canalLength_unlined: '',
    canalLength_lined: '',
    remarks: '',
  });

  const { loading, error, success, updateIaProfile } = useUpdateIaProfile();
  const formatDate = (input) => {
    const date = new Date(input);
    if (isNaN(date)) return '';
    return date.toISOString().split('T')[0]; 
  };
  

  useEffect(() => {
    if (selectedItem) {
      setFormData({
        ...selectedItem,
        name_of_irrigators: selectedItem.name_of_irrigators,
        name_of_cis: selectedItem.name_of_cis,
        municipality: selectedItem.municipality,
        district_number: selectedItem.district_number,
        mailing_address: selectedItem.mailing_address,
        name_of_iaPresident: selectedItem.name_of_iaPresident,
        contactNumber: selectedItem.contactNumber,
        date_organized: formatDate(selectedItem.date_organized),
        sec_number: selectedItem.sec_number,
        sec_date: selectedItem.sec_date,
        ia_tin: selectedItem.ia_tin,
        permit_number: selectedItem.permit_number,
        permit_date: selectedItem.permit_date,
        membership_potl: selectedItem.membership_potl,
        membership_actual: selectedItem.membership_actual,
        number_of_TSAG: selectedItem.number_of_TSAG,
        serviceArea: selectedItem.serviceArea,
        fusa: selectedItem.fusa,
        operational_area: selectedItem.operational_area,
        date_moaSigned: selectedItem.date_moaSigned,
        f_source: selectedItem.f_source,
        proj_cost: selectedItem.proj_cost,
        date_turnover: selectedItem.date_turnover,
        total_loanBalance: selectedItem.total_loanBalance,
        status: selectedItem.status,
        imtContract_dateSigning: selectedItem.imtContract_dateSigning,
        imtContract_underContract: selectedItem.imtContract_underContract,
        canalLength_unlined: selectedItem.canalLength_unlined,
        canalLength_lined: selectedItem.canalLength_lined,
        remarks: selectedItem.remarks,
      });
    }
  }, [selectedItem]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cis_id = selectedItem?.cis_id;  

    if (!cis_id) {
      alert('Invalid ID, please try again.');
      return;
    }

    await updateIaProfile(cis_id, formData);

    if (success) {
      alert('Profile updated successfully!');
      closeEditPanel();  
      navigate('/'); 
    } else if (error) {
      alert('Error: ' + error);
    }
  };

  const closePanel = () => {
    navigate(-1);
  };

  return (
    <SlidingPanel darkMode={darkMode} show={true} >
      <TopPanel darkMode={darkMode}>
        <CloseButton darkMode={darkMode}onClick={closeEditPanel}>
          <span>{'<'}</span>
        </CloseButton>

        <FormTitle darkMode={darkMode}>Edit "{formData.name_of_irrigators || 'Irrigators Association'}"</FormTitle>

        <FormButton type="submit" onClick={handleSubmit}>Save Changes</FormButton>
      </TopPanel>
      <ScrollableContainer>
        <Form onSubmit={handleSubmit}>
        <CardSection darkMode={darkMode}>

        <FieldGroup>
           <label>Name of Irrigators' Association</label>
          <input
             type="text"
             name="name_of_irrigators"
              value={formData.name_of_irrigators}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>Name of CIS/SIS-SRIS/SIP/PIP/SRIP</label>
         <input
             type="text"
             name="name_of_cis"
              value={formData.name_of_cis}
              onChange={handleInputChange}
          />
         </FieldGroup>
        

         <FieldGroup >
              <label>Municipality</label>
             <MunicipalitySelector formData={formData} setFormData={setFormData}/>
        </FieldGroup>


         <FieldGroup>
         <label>District Number</label>
         <input
             type="text"
             name="district_number"
              value={formData.district_number}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
              <label>Mailing Address</label>
             <MailingAddressSelector formData={formData} setFormData={setFormData}/>
        </FieldGroup>

         <FieldGroup>
         <label>Name of IA President</label>
         <input
             type="text"
             name="name_of_iaPresident"
              value={formData.name_of_iaPresident}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>Contact Number</label>
         <input
             type="text"
             name="contactNumber"
              value={formData.contactNumber}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>Date Organized</label>
         <input
              type="date"
              name="date_organized"
              value={formData.date_organized}
              onChange={handleInputChange}
        />

         </FieldGroup>
         </CardSection>

         <CardSection darkMode={darkMode}>
         <SectionHeader darkMode={darkMode}>SEC/CDA/DOLE Reg.</SectionHeader>
         <FieldGroup>
         <label>No.</label>
         <input
             type="text"
             name="sec_number"
              value={formData.sec_number}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>Date</label>
         <input
             type="date"
             name="sec_date"
              value={formData.sec_date}
              onChange={handleInputChange}
          />
         </FieldGroup>
         </CardSection>

        <CardSection darkMode={darkMode}>
         <FieldGroup>
         <label>IA TIN</label>
         <input
             type="text"
             name="ia_tin"
              value={formData.ia_tin}
              onChange={handleInputChange}
          />
         </FieldGroup>
         </CardSection>

          <CardSection darkMode={darkMode}>
          <SectionHeader darkMode={darkMode}>Water Permit </SectionHeader>
         <FieldGroup>
         <label>Number</label>
         <input
             type="text"
             name="permit_number"
              value={formData.permit_number}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>Date</label>
         <input
             type="date"
             name="permit_date"
              value={formData.permit_date}
              onChange={handleInputChange}
          />
         </FieldGroup>
         </CardSection>

          <CardSection darkMode={darkMode}>
          <SectionHeader darkMode={darkMode}>Membership</SectionHeader>
         <FieldGroup>
         <label> POT'L</label>
         <input
             type="text"
             name="membership_potl"
              value={formData.membership_potl}
              onChange={handleInputChange}
          />
         </FieldGroup>
         

         <FieldGroup>
         <label>Actual</label>
         <input
             type="text"
             name="membership_actual"
              value={formData.membership_actual}
              onChange={handleInputChange}
          />
         </FieldGroup>
         </CardSection>

          <CardSection darkMode={darkMode}>
         <FieldGroup>
         <label>No. of TSAG</label>
         <input
             type="text"
             name="number_of_TSAG"
              value={formData.number_of_TSAG}
              onChange={handleInputChange}
          />
         </FieldGroup>
       
         
         <FieldGroup><label>Service Area</label>
         <input
            type="text"
            name="serviceArea"
            value={formData.serviceArea}
            onChange={handleInputChange}
        />
         </FieldGroup>
        
         <FieldGroup>
         <label>FUSA</label>
         <input
             type="text"
             name="fusa"
              value={formData.fusa}
              onChange={handleInputChange}
          />
         </FieldGroup>
        
         <FieldGroup>
         <label>Operational Area</label>
         <input
             type="text"
             name="operational_area"
              value={formData.operational_area}
              onChange={handleInputChange}
          />
         </FieldGroup>
         </CardSection>


         <CardSection darkMode={darkMode}>
         <SectionHeader darkMode={darkMode}>Original Construction</SectionHeader>
         <FieldGroup>
         <label>Date of MOA signed</label>
         <input
             type="text"
             name="date_moaSigned"
              value={formData.date_moaSigned}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>F-Source</label>
         <input
             type="text"
             name="f_source"
              value={formData.f_source}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>Project Cost</label>
         <input
             type="text"
             name="proj_cost"
              value={formData.proj_cost}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>Date of Turnover</label>
         <input
             type="text"
             name="date_turnover"
              value={formData.date_turnover}
              onChange={handleInputChange}
          />
         </FieldGroup>
         </CardSection>
         
         <CardSection darkMode={darkMode}>
         <FieldGroup>
         <label>Total IA Loan Balance</label>
         <input
             type="text"
             name="total_loanBalance"
              value={formData.total_loanBalance}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>Status</label>
         <input
             type="text"
             name="status"
              value={formData.status}
              onChange={handleInputChange}
          />
         </FieldGroup>
         </CardSection>

         <CardSection darkMode={darkMode}>
         <SectionHeader darkMode={darkMode}>IMT Contract </SectionHeader>
         <FieldGroup>
         <label>Date of Signing</label>
         <input
             type="text"
             name="imtContract_dateSigning"
              value={formData.imtContract_dateSigning}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label> Area Under Contract</label>
         <input
             type="text"
             name="imtContract_underContract"
              value={formData.imtContract_underContract}
              onChange={handleInputChange}
          />
         </FieldGroup>
         </CardSection>

         <CardSection darkMode={darkMode}>
         <SectionHeader darkMode={darkMode}>Canal Length  </SectionHeader>
         <FieldGroup>
         <label>Unlined</label>
         <input
             type="text"
             name="canalLength_unlined"
              value={formData.canalLength_unlined}
              onChange={handleInputChange}
          />
         </FieldGroup>

         <FieldGroup>
         <label>Lined</label>
         <input
             type="text"
             name="canalLength_lined"
              value={formData.canalLength_lined}
              onChange={handleInputChange}
          />
         </FieldGroup>
         </CardSection>

         <CardSection darkMode={darkMode}>
         <FieldGroup>
         <label>Remarks</label>
         <input
             type="text"
             name="remarks"
              value={formData.remarks}
              onChange={handleInputChange}
          />
         </FieldGroup>
         </CardSection>
     
        </Form>
      </ScrollableContainer>
    </SlidingPanel>
  );
};

export default IaProfilingEdit;

// Styled components remain unchanged


const SlidingPanel = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 99%;
  height: 100%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#f2f2f2')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  
  background-size: cover;
  background-position: center;
  box-shadow: ${({ darkMode }) =>
    darkMode ? '0 3px 8px rgba(255, 255, 255, 0.4)' : '0 3px 10px rgba(0, 0, 0, 0.05)'};
  transform: translateX(100%);
  transition: transform 0.5s ease;
  z-index: 9999;
  padding: 20px;
  box-sizing: border-box;

  ${({ show }) => show && `transform: translateX(0);`}
`;

const TopPanel = styled.div`
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#f2f2f2')};
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
  padding: 5px 5px;
`;
const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormTitle = styled.h2`
  font-size: 15px;
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
  font-weight: bold;
  margin-top: 30px;
`;

const CloseButton = styled.button`
  background-color: transparent;
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
  margin-top: 20px;
  margin-left: -29px;
  padding: 10px;
`;

const CardSection = styled.div`
  background: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#f2f2f2')};
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 10px;
  box-shadow: ${({ darkMode }) =>
    darkMode ? '0 2px 8px rgba(255, 255, 255, 0.1)' : '0 2px 8px rgba(0, 0, 0, 0.05)'};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const SectionHeader = styled.h3`
  grid-column: span 2;
  font-size: 1rem;
  margin-bottom: 10px;
  color: ${({ darkMode }) => (darkMode ? '#333' : '#333')};
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
`;




const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; /* Changed from 3 columns to 2 */
  gap: 20px;
  padding: 10px;
  background-color: ${({ darkMode }) => (darkMode ? 'rgb(36, 110, 45)' : '#f9f9f9')};
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #f2f2f2;
  border-radius: 8px;
`;


const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-size: 0.75rem;
    margin-bottom: 5px;
    color: ${({ darkMode }) => (darkMode ? '#ddd' : '#666')};
  }

  input {
    padding: 10px 12px;
    font-size: 0.9rem;
    border-radius: 6px;
    border: 1px solid #ccc;
    background-color: ${({ darkMode }) => (darkMode ? '#3a4b3a' : '#fafafa')};
    color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
    transition: border 0.2s ease;

    &:focus {
      border-color: #218838;
      outline: none;
    }
  }
`;


const FormButton = styled.button`
  padding: 8px 5px;
  font-size: 13px;
  background-color: #218838;
  color: white;
  margin-top: 8px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #1c7c2a;
  }
`;


const ScrollableContainer = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  padding-right: 10px;
`;
